import i18n from 'i18next';
import { useEffect, useState } from 'react';
import { getShipmentStatusListEffect, getShipmentStatusListQuote } from '../../../redux/shipment/ShipmentEffects';
import FormSelectBox from '../Inputs/FormSelectBox';

const ShipmentStatusSelector = ({
  placeholder = i18n.t('translation:default.fields.status.placeholder'),
  label = i18n.t('translation:default.fields.status.label'),
  rules = [],
  name,
  editMode,
  margin,
  readOnly,
  disabled,
  mode,
  quoteType,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getStatusList();
  }, []);

  const getStatusList = async () => {
    try {
      setLoading(true);
      const { data } =
        quoteType === 'search' ? await getShipmentStatusListQuote() : await getShipmentStatusListEffect();
      const options =
        quoteType !== 'search'
          ? data.map((row) => ({
              label: row.status,
              value: row.status,
            }))
          : data.map((status) => ({
              label: status,
              value: status,
            }));
      setOptions(options);
      setLoading(false);
    } catch {
      setOptions([]);
      setLoading(false);
    }
  };

  return (
    <FormSelectBox
      loading={loading}
      options={options}
      placeholder={placeholder}
      label={label}
      rules={rules}
      name={name}
      editMode={editMode}
      margin={margin}
      readOnly={readOnly}
      disabled={disabled}
      mode={mode}
    />
  );
};

export default ShipmentStatusSelector;
